enum ActionTypes {
  FETCH_DICTIONARY_START = "FETCH_DICTIONARY_START",
  FETCH_DICTIONARY_SUCCESS = "FETCH_DICTIONARY_SUCCESS",
  FETCH_DICTIONARY_ERROR = "FETCH_DICTIONARY_ERROR",
}

export default ActionTypes;
